import {configureStore} from "@reduxjs/toolkit";

import user from './slices/userSlice';
import platformNav from './slices/platform/PlatformNavSlice';
export default configureStore({
    reducer: {
        user: user,
        platformNav: platformNav,
    },
});